import {
  GET_MERCHANT_PROFILE,
  GET_MERCHANT_PROFILE_ERROR,
  CREATE_MERCHANT_PROFILE_SUCCESS,
  CREATE_MERCHANT_PROFILE_FAILED,
  CREATE_MERCHANT_PROFILE_PENDING,
  EDIT_MERCHANT_PROFILE_SUCCESS,
  EDIT_MERCHANT_PROFILE_FAILED,
  EDIT_MERCHANT_PROFILE_PENDING
} from "../constants/MerchantConstants";

const initialState = {
  merchant: [],
  loading: true
};
const merchantReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MERCHANT_PROFILE:
      return {
        ...state,
        merchant: action.payload,
        loading: false
      };
    case GET_MERCHANT_PROFILE_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const postMerchant = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_MERCHANT_PROFILE_PENDING:
      return Object.assign({}, state, { loading: true });
    case CREATE_MERCHANT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        merchant: action.payload
      });
    case CREATE_MERCHANT_PROFILE_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const patchMerchant = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_MERCHANT_PROFILE_PENDING:
      return Object.assign({}, state, { loading: true });
    case EDIT_MERCHANT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        merchant: action.payload
      });
    case EDIT_MERCHANT_PROFILE_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const editMerchantProfile = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_MERCHANT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        merchant: action.payload
      });
    default:
      return state;
  }
};
export default merchantReducer;
